module.exports = __webpack_public_path__ + "img/innisfree3.d6b9af45.jpg";